/*
* 本项目所使用的正则表达式
* */

// 手机号正则
export const regPhone = /(^1[2|3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;

// 邮箱正则
export const regEmail = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;

// 数字正则
export const regNumber = /^[0-9]+(.[0-9]{2})?$/;

// 身份证正则表达式
export const idCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/



// WEBPACK FOOTER //
// ./src/utils/validate.js